var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content details-page"},[_c('div',{staticClass:"ql-snow"},[_c('div',{staticClass:"product-info-wrap ql-editor",domProps:{"innerHTML":_vm._s(_vm.info.details)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }